/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import { getCdnUrl } from '../../services/environment'

interface ImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
}

const Img: React.FC<ImgProps> = ({ src, ...props }) => {
  const [resolvedSrc, setResolvedSrc] = useState<string | null>(null)

  useEffect(() => {
    // If src already starts with http/https, use as-is
    if (/^https?:\/\//.test(src)) {
      setResolvedSrc(src)
      return
    }

    // For relative paths, use CDN URL (reads from cdn-url attribute or falls back to window.location)
    const cdnUrl = getCdnUrl()
    // Remove leading slash from src if cdnUrl already ends with one
    const normalizedSrc = src.startsWith('/') ? src.slice(1) : src
    const finalUrl = cdnUrl.endsWith('/') ? cdnUrl + normalizedSrc : cdnUrl + '/' + normalizedSrc
    setResolvedSrc(finalUrl)
  }, [src])

  if (!resolvedSrc) {
    return null
  }

  return <img {...props} src={resolvedSrc} />
}

export default Img
